import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

// MODELOS
import { LoginAccessModel, LoginAccessResponse, PermResponse, PermsModel } from './../../../models/index'

// RUTAS
// COMPONENTES
// SERVICIOS
import { AuthenticationService, } from './../../../services/authentication.service';
import { AlertService, StorageService} from './../../../services/index'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  User: string; // variable para contener al usuario que se logeo en la app para encuesta  
  errorMessage: string; // variable para el mensaje en caso de error
  PermList: Array<PermsModel>; // almacena la lista de permisos activos del usuario

  constructor(private activatedRoute: ActivatedRoute,
    private authSevice: AuthenticationService,
    private alertService: AlertService,
    private storageService: StorageService) {
    console.log("Llego");
  }

  ngOnInit() {
    this.User = this.activatedRoute.snapshot.paramMap.get('user');
    console.log("Usuario recibido------");
    console.log(this.User);
    this.getToken();
       
  }

 async getToken(){
  let result = (await this.authSevice.getToken(this.User)).toPromise();
  let token = (await result).access_token;
  this.storageService.setStorage('access_token',token);
   this.checkUser(); 
  }

  async checkUser() {
    this.blockUI.start('Obteniendo información del usuario, espere por favor...');
    console.log('Validando usuario');
    if(this.User != null && this.User != ''){      
      this.authSevice.checkUser(this.User)
      .subscribe((data: PermResponse) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          // verifica si tiene permiso, Acceso o SuperUser y que este activo
          this.PermList = data.PermsList;
          let Permission = data.PermsList.filter(x => x.PermName === 'MISIntMor_Access' || x.PermName === 'MISIntMor_SuperUser');
          let email = data.PermsList[0].Email;
          if(Permission[0].Active){
            this.authSevice.login(this.User, email);
            this.storageService.setPerms(this.PermList);
          }
          else{
            this.alertService.warningAlert(`Sin permiso de acceso`);
          }
          this.blockUI.stop();          
        } else {
          this.blockUI.stop();
          console.log(data.errorInfo.Message);
          this.errorMessage = data.errorInfo.Message;
          this.alertService.warningAlert(`${data.errorInfo.Message}`);
          //this.authSevice.logout();          
        }
      }, (error: any) => {
        this.blockUI.stop();
        console.log(error);
        //this.alertService.errorAlert(`${error}`);
      });
    }
    else{
      this.blockUI.stop();
      return '';
    }
  }
}
